import { post, get } from '@web3/base-utils';
import {
  WalletConfigRes,
  WalletStatRes,
  WalletTotalPointRes,
  WalletTypePointRes,
  WalletPointLog,
  CheckinHistoryItem,
  WalletBase,
  TradeHistoryItem,
} from '../types';

/**
 * 11. 积分配置
 */
export const getWalletConfig = () => {
  return get<WalletConfigRes>(`/web3/api/point/v1/wallet/config`);
};

/**
 * 平台积分数据查询
 * @returns
 */
export const getWalletStat = (params?) => {
  return get<WalletStatRes>(`/web3/api/point/v1/wallet/stat`, params);
};

/**
 * 用户总积分查询
 * @param data
 * @returns
 */
export const getWalletTotalPoints = (params: WalletBase) => {
  return get<WalletTotalPointRes>(
    `/web3/api/point/v1/wallet/total/point`,
    params
  );
};

/**
 * 用户待领取积分查询
 * @param data
 * @returns
 */
export const getWalletTypePoints = (
  params: {
    type: number | string;
  } & WalletBase
) => {
  return get<WalletTypePointRes[]>(`/web3/api/point/v1/wallet/point`, params);
};

/**
 * 用户积分领取
 * @param data
 * @returns
 */
export const postClaimtTypePoints = (
  data: {
    type?: number;
  } & WalletBase
) => {
  return post<Boolean>(`/web3/api/point/v1/wallet/claim`, data);
};

/**
 * 用户积分领取
 * @param data
 * @returns
 */
export const postMediaTypePoints = (
  data: {
    accessToken?: string;
    refreshToken?: string;
  } & WalletBase
) => {
  return post<Boolean>(`/web3/api/point/v1/wallet/media`, data);
};

/**
 * 用户积分领取记录
 * @param data
 * @returns
 */
export const getWalletPointsLog = (params: {
  walletId: string;
  page: number;
  size: number;
}) => {
  return get<WalletPointLog[]>(`/web3/api/point/v1/wallet/claim/log`, {
    params,
  });
};

/**
 * 最新获取积分钱包地址(轮播)
 */
export const getWalletLatest = () => {
  return get<{ walletId: string; address: String; point: number }[]>(
    `/web3/api/point/v1/wallet/latest`
  );
};

/**
 * 用户签到历史
 */
export const getCheckinHistory = (params: WalletBase) => {
  return get<CheckinHistoryItem[]>(
    `/web3/api/point/v1/wallet/checkin/history`,
    params
  );
};

/**
 * 用户签到
 * @param data
 * @returns
 */
export const postCheckin = (
  data: {
    accessToken?: string;
    refreshToken?: string;
  } & WalletBase
) => {
  return post<Boolean>(`/web3/api/point/v1/wallet/checkin`, data);
};

/**
 * 用户交易历史记录
 */
export const getTradeHistory = (
  params: {
    fromId: number;
    limit: number;
    direct: -1 | 1;
  } & WalletBase
) => {
  return get<TradeHistoryItem[]>(
    `/web3/api/point/v1/wallet/trade/history`,
    params
  );
};

/**
 * 资沉是否达标
 */
export const getWalletAsset = (params: WalletBase) => {
  return get<{ capital: boolean }>(`/web3/api/point/v1/wallet/asset`, params);
};
